module.exports = __webpack_public_path__ + "static/media/img4.c7376069.jpg";